import React, { useEffect } from 'react';
import Contact from '../components/Contact';
import { motion } from 'framer-motion';
import { siteConfig } from '../data';

const ContactPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-20">
      {/* Simple Hero for Contact Page */}
      <section className="bg-slate-50 py-16 md:py-24">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="text-4xl md:text-6xl font-black text-slate-900 uppercase tracking-tighter mb-6">
              Kontakt os
            </h1>
            <p className="text-xl text-slate-600 max-w-2xl font-medium leading-relaxed">
              Vi er her for at hjælpe dig med dine energiprojekter. Kontakt vores specialister for teknisk rådgivning, priser eller partnerskabsmuligheder.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Main Contact Section */}
      <Contact />

      {/* Additional Info Section */}
      <section className="py-24 bg-slate-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            <div>
              <h4 className="text-sm font-black text-slate-900 uppercase tracking-widest mb-4">Hovedkontor</h4>
              <p className="text-slate-600 font-medium leading-relaxed">
                {siteConfig.contact.address}<br />
                {siteConfig.contact.zipCity}<br />
                Danmark
              </p>
            </div>
            <div>
              <h4 className="text-sm font-black text-slate-900 uppercase tracking-widest mb-4">Åbningstider</h4>
              <p className="text-slate-600 font-medium leading-relaxed">
                Mandag - Torsdag: 08:30 - 16:30<br />
                Fredag: 08:30 - 15:30<br />
                Weekend: Lukket
              </p>
            </div>
            <div>
              <h4 className="text-sm font-black text-slate-900 uppercase tracking-widest mb-4">Support</h4>
              <p className="text-slate-600 font-medium leading-relaxed">
                For teknisk support døgnet rundt,<br />
                venligst benyt vores dedikerede<br />
                service-portal.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
